export default {

  subjectMap: {
    0: { name: 'common.selects.all_subjects' },
    9999: { name: 'common.selects.placeholder' },
  },

  gradeMap: {
    0: { name: 'common.selects.all_grades' },
    9999: { name: 'common.selects.placeholder' },
    null: { name: 'common.selects.others' },
  },

  domains: {},

  coreConcepts: {},

  units: {},

  pageTypes: {
    multiple_choice: 'common.page_types.multiple_choice',
    text_entry: 'common.page_types.text_entry',
    essay_type: 'common.page_types.essay_type',
  },
};
